export default __webpack_public_path__ + "static/media/IBMPlexSans-Regular.0519459d.ttf";